import React from 'react'

import TableHeader from './header'
import Row from './row'
import './list.css'
import './table-column-sizes.css'
import ReactTooltip from 'react-tooltip'
import ACLCheckPermission from '../ACLCheckPermission'

export default ({ list, showEdit, loading, onadd, onEdit, onRemove }) => {
    return (
        <div>
            <div className="row">
                <div className="col">
                    <div className="text-right">
                        <ACLCheckPermission api="/role" method="POST">
                            <ReactTooltip id="createBtnTooltip" type="dark" effect="solid">
                                <span>Create a new Role</span>
                            </ReactTooltip>
                            <button data-tip data-for="createBtnTooltip" onClick={() => onadd()} className="border-button inlinebuttons">
                                New Role
                            </button>
                        </ACLCheckPermission>
                    </div>
                </div>
            </div>
            <table className="license-list license-list--table">
                <TableHeader showEdit={showEdit} />
                <tbody>
                    {list.map((r, index) => (
                        <Row showEdit={showEdit} onEdit={onEdit} onRemove={onRemove} index={index} key={index} row={r} />
                    ))}
                    {loading && (
                        <tr>
                            <td colSpan={8} style={{ textAlign: 'center' }}>
                                <button type="button" className="btn btn-link property-list property-list--load-more-button" disabled>
                                    Loading...
                                </button>
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    )
}
